export default {
      id: "icon-download-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-download",
      toString: function () {
        return this.url;
      }
    }